import { SliderField } from './SliderField';
import { useNode } from '@craftjs/core';
import type { ImageProps } from '@builder4/shared/components/Image';
import { useBreakpointAwareProp } from '@/hooks/useBreakpointAwareProp';

const NodeScaleSettings = () => {
  const {
    actions: { setProp },
    props,
    displayName,
  } = useNode((node) => ({
    props: node.data.props,
    displayName: node.data.displayName,
  }));

  const { getBPProp, setBPProp } = useBreakpointAwareProp(displayName);
  const backgroundSize = getBPProp(props, 'backgroundSize');
  const parsedValue = parseInt(backgroundSize?.replace?.('%', '') || '0', 10);
  return (
    <SliderField
      label="Scale"
      value={parsedValue}
      onChange={(e) => {
        setProp((props: Partial<ImageProps>) => {
          setBPProp(props, 'backgroundSize', `${e}%`);
        }, 500);
      }}
      min={1}
      max={200}
    />
  );
};

export default NodeScaleSettings;
